import { useState } from "react";
import { Instagram, Facebook, Youtube, Mail, MapPin } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Reveal, Overline } from "@/components/Reveal";

export default function Contact() {
    const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/contact", form);
            toast.success("Message received. Sherrie will reach out soon.");
            setForm({ name: "", email: "", subject: "", message: "" });
        } catch { toast.error("Could not send message."); }
        setBusy(false);
    };

    const input = "w-full bg-surface border border-gold/20 rounded-xl px-4 py-3 text-cream placeholder:text-faded focus:outline-none focus:ring-1 focus:ring-gold";

    return (
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-2 gap-14">
            <Reveal>
                <Overline>Reach Out</Overline>
                <h1 className="mt-3 font-serif text-5xl text-cream">Reach the House</h1>
                <p className="mt-4 text-ash">Questions about a working, a custom request, or a wholesale inquiry, send a note and the house will respond personally.</p>
                <div className="mt-8 space-y-4 text-ash">
                    <div className="flex items-center gap-3"><Mail className="w-5 h-5 text-gold" /> hello@sacredearthworks.com</div>
                    <div className="flex items-center gap-3"><MapPin className="w-5 h-5 text-gold" /> The Fourth Bluff · Memphis, Tennessee · Consultations worldwide</div>
                </div>
                <div className="flex gap-3 mt-8">
                    {[Instagram, Facebook, Youtube].map((Icon, i) => (
                        <a key={i} href="#" className="w-10 h-10 rounded-full border border-gold/25 flex items-center justify-center text-ash hover:text-gold hover:border-gold/50 transition-colors"><Icon className="w-4 h-4" /></a>
                    ))}
                </div>
            </Reveal>

            <Reveal delay={0.1}>
                <form onSubmit={submit} className="p-7 rounded-2xl bg-surface border border-gold/15" data-testid="contact-form">
                    <div className="space-y-4">
                        <input required placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={input} data-testid="contact-name" />
                        <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} data-testid="contact-email" />
                        <input placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className={input} data-testid="contact-subject" />
                        <textarea required rows={5} placeholder="How can Sherrie help?" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={input} data-testid="contact-message" />
                    </div>
                    <button disabled={busy} data-testid="contact-submit" className="mt-6 w-full bg-gold text-ink rounded-full py-3 font-medium hover:bg-goldbright transition-colors active:scale-95 disabled:opacity-60">
                        {busy ? "Sending…" : "Send Message"}
                    </button>
                </form>
            </Reveal>
        </div>
    );
}
